// extracted by mini-css-extract-plugin
export default {"wrapper":"store-links_wrapper__mmSj+","appStore":"store-links_appStore__c9OXd","googlePlay":"store-links_googlePlay__Y9Owu"};